import React, { useState, useEffect } from "react";
import { Box, IconButton, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

/**
 * BackToTop — floating button at bottom-right corner.
 * Appears after scrolling down 300px. auto-scrolls to top on click.
 * Drop this into UserLayout.js alongside the navbar components.
 */
const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "auto" });
  };

  return (
    <Zoom in={visible}>
      <Box
        sx={{
          position: "fixed",
          bottom: 32,
          right: 32,
          zIndex: 2000,
        }}
      >
        <IconButton
          onClick={handleClick}
          aria-label="Back to top"
          sx={{
            width: 48,
            height: 48,
            backgroundColor: "#C59324",
            color: "#0A192F",
            boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
            "&:hover": {
              backgroundColor: "#A67C1E",
              transform: "translateY(-3px)",
              boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
            },
            transition: "all 0.2s ease",
          }}
        >
          <KeyboardArrowUpIcon sx={{ fontSize: "1.6rem" }} />
        </IconButton>
      </Box>
    </Zoom>
  );
};

export default BackToTop;